import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { ReportIcon } from "@common/reportIcon";
import { ProjectIcon } from "./projectIcon";
import { GanttIcon } from "./ganttIcon";
import { ZonesIcon } from "./zonesIcon";
import { ListIcon } from "./listIcon";
import { WorkloadsIcon } from "./workloadsIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Navigation(_: Props) {
  const { t } = useTranslation();

  return (
    <ul className={styles.navigation}>
      <li className={styles.item}>
        <NavLink
          to="/zones"
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
          end
        >
          <ZonesIcon className={styles.icon} />
          <p className={styles.text}>{t("zonesPage.navigation.zones")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to="/zones/projects"
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <ProjectIcon className={styles.icon} />
          <p className={styles.text}>{t("zonesPage.navigation.projects")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to="/zones/lists"
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <ListIcon className={styles.icon} />
          <p className={styles.text}>{t("zonesPage.navigation.list")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to="/zones/gantt"
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <GanttIcon className={styles.icon} />
          <p className={styles.text}>{t("zonesPage.navigation.gantt")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to="/zones/reports"
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <ReportIcon className={styles.icon} />
          <p className={styles.text}>{t("zonesPage.navigation.reports")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to="/zones/workloads"
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <WorkloadsIcon className={styles.icon} />
          <p className={styles.text}>{t("zonesPage.navigation.workloads")}</p>
        </NavLink>
      </li>
    </ul>
  );
}

export { Navigation };
